
(function () {
  angular
    .module('specsguardApp')
    .directive('sgWidget', sgWidget);

  function sgWidget () {
    function LinkFunc (scope, el, attr) {}
    return {
      restrict: 'E',
      templateUrl: 'app-legacy/components/sg-widget/sg-widget/sg-widget.html',
      controller: 'sgWidgetsCtrl',
      controllerAs: '$sgWidgetsCtrl',
      require: '^sg-widgets-ctrl',
      transclude: false,
      bindToController: {
        widgets: '=',
      },
    };
  }
})();
